<template>
  <div class="drawer">
    <el-drawer
      size="650px"
      :visible.sync="drawerStatus"
      @close="close"
      :title="'欠宠换宠'"
      :wrapperClosable="false"
    >
      <!-- <div class="msgBox">
        <span>说明:</span>
        <div>
          <el-input type="textarea" v-model="remark" aria-placeholder="不能少于15字"></el-input>
        </div>
      </div>-->

      <div>
        <div class="msgBox">
          <span>替换宠物:</span>
        </div>
        <div style="display:flex;padding: 20px;justify-content:space-between;">
          <!-- <span>
            芯片号:
            <el-input v-model="input2" placeholder="请输入芯片号" style="width:150px"></el-input>
          </span>
          <span>
            脖圈号:
            <el-input v-model="input1" placeholder="请输入脖圈号" style="width:150px"></el-input>
          </span> -->
          <el-button type="primary" plain  @click="getInfo">获取宠物</el-button>
        </div>
        <div style="padding:20px">
          <el-table :data="tableData" default-expand-all style="width: 100%;margin-bottom: 10px;">
            <el-table-column label="活体" property="product.inside_name"></el-table-column>
            <el-table-column label="芯片号" property="product.inside_no"></el-table-column>
            <el-table-column label="脖圈号" property="product.eprom_no"></el-table-column>

            <el-table-column prop="price" label="售价" property="price"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="del(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <hr />

        <div class="msgBox">
          <span>补差价</span>
        </div>
        <div class="msg">
          <div>原宠物 金额:￥{{tabInfo.return_pet.pet_price}}</div>
          <div v-show="isShow">替换宠物 金额:￥{{info.price}}</div>
          <div v-show="isShow">需补差价 金额:￥{{info.price?info.price-tabInfo.return_pet.pet_price:''}}</div>
        </div>
        <div style="display:flex">
          <div style="margin-left:20px;vertical-align: middle;height: 40px;line-height: 40px;">
            补差价销售人员:
          </div>
          <el-select class="select" multiple v-model="curStaff" filterable placeholder="请选择">
            <el-option
              popper-class="select"
              v-for="item in staffList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </div>
      </div>

      <!-- 宠物列表 -->
      <el-dialog title="宠物列表" :visible.sync="dialogTableVisible" :append-to-body="true">
        <drawerListProduct @submit="add"></drawerListProduct>
      </el-dialog>
      <div style="height:40px;width:100%"></div>
      <div class="btnBox">
        <div class="btnItem" @click="close">取消</div>
        <div class="btnItem submit" @click="submit">确定</div>
      </div>
    </el-drawer>
  </div>
</template>
  
  <script>
import drawerListProduct from "./drawer_list.vue"
export default {
  components: {
    drawerListProduct
  },
  props: {

    tabInfo: {
      default: {},
    },

  },
  data () {
    return {
      isShow:false,
      pet_price: '',
      tableData: [],
      drawerStatus: false,
      formLabelWidth: '80px',
      remark: '',//换宠备注
      curStaff: [],  // 销售人员
      staffList: [],//销售人员列表
      input1: '',//芯片号
      input2: '',//脖圈号
      type: '1',
      info: {},
      b: '',
      dialogTableVisible: false,
      curStaff1: '',//换宠销售
      saleManIdList: [],
      newPetInfo: {
        pet_id: '',
        pet_name: '',
        pet_price: '',
        eprom_no: '',
        inside_no: '',
        price: ''
      }
    }
  },
  computed: {

  },
  mounted () {
    // console.log('传串串', this.tabInfo);
    this.$nextTick(() => {
      this.drawerStatus = true;
    })
    this.getStaffList();
  },
  methods: {
    //删除
    del (i) {
      this.isShow=false;
      this.info.price='';
      this.newPetInfo.pet_name=''
      this.tableData.splice(i, 1);
    },
    add (a) {
      this.dialogTableVisible = false;
      console.log(a);
      this.info = a;
      this.input1 = a.product.eprom_no;
      this.input2 = a.product.inside_no;
      this.tableData.push(a);
      if (this.info) {
        this.isShow=true;
        this.newPetInfo.pet_id = a.product.pet_id;
        this.newPetInfo.pet_name = a.product.inside_name;
        this.newPetInfo.pet_price = a.price;
        this.newPetInfo.eprom_no = a.product.eprom_no;
        this.newPetInfo.inside_no = a.product.inside_no;
        this.newPetInfo.price = this.info.price - this.tabInfo.return_pet.pet_price;//差价
      }
    },
    // 获取宠物列表
    getInfo () {
      if (this.tableData.length > 0) {
        this.$message({
            type: "error",
            message: "只能退换一只宠物",
          });
          return;
      }
      this.dialogTableVisible = true;
    },
    submit () {
      if (this.$public.isNull(this.newPetInfo.pet_name)) {
        this.$message({
          type: "error",
          message: "请选择要替换的宠物",
        });
        return;
      }
      var arr = []
      this.staffList.forEach((itemA) => {
        this.curStaff.forEach((itemB) => {
          if (itemA.name === itemB) {
            const obj = {
              sales_id: itemA.id,
              sales_name: itemA.name
            }
            arr.push(obj)
          }
        })
      });
      if (this.$public.isNull(arr)) {
        this.$message({
          type: "error",
          message: "销售人员不为空",
        });
        return;
      }
      let loading = this.$loading()
      let params = {
        "id": this.tabInfo._id,
        "sales_list": arr,//补差价销售人员信息
        "newPetInfo": this.newPetInfo
      }
      console.log(params)
      this.$http.post('/api/ReturnOrder/Return/PetOweReplace', params).then(res => {
        console.log('换欠宠', res);
        loading.close()
        if (res.code === 0) {
          this.$emit('submit', { type: 'close' })
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          //   this.delInfo();
        }
      })
    },

    // 获取销售人员列表
    getStaffList () {
      let params = {
        "keyword": '', //关键字
        "pageIndex": 1,
        "pageSize": 100,
      }
      this.$http.get('/api/Staff/List', params).then(res => {
        if (res.code == 0) {
          this.saleManIdList = res.data.data;
          res.data.data.forEach((item) => {
            const obj = {
              id: item._id,
              name: item.basic_info.nick_name
            }
            this.staffList.push(obj)
          })
          const name = this.tabInfo[0].staff.trim();
          this.staffList.forEach((item) => {
            if (item.name === name) {
              this.curStaff.push(item.name);
            }
          })
        }
      })
    },
    close () {
      this.$emit('submit', { type: 'close' })
    },
  },
}

  </script>
  
  <style scoped lang="scss">
.msg {
  div {
    margin-bottom: 10px;
    margin-left: 20px;
  }
}
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .el-drawer__body {
      overflow: auto;
    }
  }
}
.msgBox {
  display: flex;
  padding: 20px;
  & > span {
    font-weight: 600;
    display: inline-block;
    padding: 20px;
    text-align: right;
  }
}
.btnBox {
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 10;
  .btnItem {
    text-align: center;
    width: 100%;
    background-color: #d6d6d6;
    cursor: pointer;
    &.submit {
      background-color: $mainColor;
    }
  }
}
.imgItem {
  position: relative;
  margin-right: 15px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
  background: #f0f0f7;
  border: 1px dashed #b0b0bf;
  border-radius: 8px;
  box-sizing: border-box;
}
.avatar {
  width: 128px;
  height: 128px;
  display: block;
  object-fit: cover;
}
.imgItem i {
  position: absolute;
  top: -10px;
  right: -10px;
}
::v-deep .el-dialog {
  width: 80%;
  margin: auto;
}
</style>
  